import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

const useCompletedStep = step => {
  const router = useRouter();
  const { transactionId } = router.query;

  const key = `${transactionId}.completed.${step}`;

  const initialValue =
    typeof window === 'object' && window.localStorage.getItem(key) === 'true';

  const [isStepCompleted, setIsStepCompletedState] = useState(initialValue);

  useEffect(() => {
    setIsStepCompletedState(window.localStorage.getItem(key) === 'true');
  }, [key]);

  const setIsStepCompleted = () => {
    if (typeof window === 'object') {
      window.localStorage.setItem(key, 'true');
      setIsStepCompletedState(true);
    }
  };

  return [isStepCompleted, setIsStepCompleted];
};

export default useCompletedStep;
